/**
 * `"18 m"`, `"3 h 12 m"`, or `"2 d 06 h"`: the two coarsest non-zero units, the shape of the
 * backend's `processing/format.ts`. A copy, not an import (the packages share no build), so the
 * ages the console builds read like the ages the backend writes. Never negative.
 */
export function formatDuration(ms: number): string {
  const totalMinutes = Math.max(0, Math.round(ms / 60_000));
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  if (days > 0) return `${days} d ${pad(hours)} h`;
  if (hours > 0) return `${hours} h ${pad(minutes)} m`;
  return `${minutes} m`;
}
